import React from 'react';
import { Trans } from '@lingui/macro';
import { Text, Box, Flex } from '@landr/maestro';
import { LrLogo } from '../../SVGs';

const Logo: React.FC = () => (
    <Flex
        justifyContent="center"
        alignItems="center"
        flexDirection={{ base: 'column', lg: 'row-reverse' }}
        gap="md"
        mb="xl"
    >
        <Box>
            <Text textStyle="body-sm" color="text.medium">
                &copy; {new Date().getFullYear()}&nbsp;LANDR.
            </Text>{' '}
            <Text textStyle="body-sm" color="text.medium">
                <Trans>All rights reserved</Trans>
            </Text>
        </Box>
        <LrLogo />
    </Flex>
);

export default Logo;
